import { request } from "@/service/request.js";

// 散客票列表
export function getEffective(options) {
    options.channel = 'weixin'
    return request.call(this, {
        url: "openapi/individualOrder/list",
        method: 'POST',
        data: options
    });
};

// 导游票列表
export function getGroupOrder(options) {
    options.channel = 'weixin'
    return request.call(this, {
        url: "openapi/groupOrder/list",
        method: 'POST',
        data: options
    });
};

// 免费票列表
export function getFreeTicketOrder(options) {
    options.channel = 'weixin'
    return request.call(this, {
        url: "openapi/freeTicketOrder/list",
        method: 'POST',
        data: options
    });
};

// 散客订单批量删除接口
export function getIndividualOrderBatchDelete(options) {
    options.channel = 'weixin'
    return request.call(this, {
        url: "openapi/web/individual/order/batchDelete",
        method: 'POST',
        data: options
    });
};

// 团体订单批量删除接口
export function getGroupOrderBatchDelete(options) {
    options.channel = 'weixin'
    return request.call(this, {
        url: "openapi/web/group/order/batchDelete",
        method: 'POST',
        data: options
    });
};

// 免费订单批量删除接口
export function getFreelOrderBatchDelete(options) {
    options.channel = 'weixin'
    return request.call(this, {
        url: "openapi/web/free/order/batchDelete",
        method: 'POST',
        data: options
    });
};
